import React, { useRef } from "react";
import { Modal, Button } from "react-bootstrap";
import { QRCodeCanvas } from "qrcode.react";
import QRCode from "react-qr-code";

const QRCodeModal = ({ textToEncode, showModal, setShowModal }) => {
  const qrCanvasRef = useRef(null); // Ref to QRCodeCanvas

  // Function to download the qr
  /*const downloadQRCode = () => {
    if (qrCanvasRef.current) {
      const canvas = qrCanvasRef.current;
      const url = canvas.toDataURL("image/png");
      const link = document.createElement("a");
      link.href = url;
      link.download = "qr-code.png";
      link.click();
    } else {
      console.error("QR code canvas no encontrado.");
    }
  };*/

    // Función para descargar el QR
    const downloadQRCode = () => {
      const svg = document.querySelector("svg");
      const svgData = new XMLSerializer().serializeToString(svg);
      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d");
      const img = new Image();
      img.onload = () => {
        canvas.width = img.width;
        canvas.height = img.height;
        ctx.drawImage(img, 0, 0);
        const pngFile = canvas.toDataURL("image/png");
        const downloadLink = document.createElement("a");
        downloadLink.href = pngFile;
        downloadLink.download = "qr-code.png";
        downloadLink.click();
      };
      img.src = `data:image/svg+xml;base64,${btoa(svgData)}`;
    };

  return (
    <div>
      {/* Modal of react-bootstrap */}
      <Modal show={showModal} onHide={() => setShowModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>QR Generado</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {/* canvas of qr */}
          <div className="text-center">
            

            <QRCode
              value={textToEncode} // Asegúrate de que siempre haya texto
              size={200} // Tamaño del QR
              bgColor="#ffffff" // Color de fondo
              fgColor="#000000" // Color del texto
              level="H" // Nivel de corrección de errores
            />
            
          </div>
          <h1 className="text-center m-3">Codigo: {textToEncode}</h1>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Cerrar
          </Button>
          <Button variant="primary" onClick={downloadQRCode}>
            Descargar QR
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default QRCodeModal;